import PasswordField from './PasswordField';

export { default as PasswordTextField } from './PasswordTextField';
export default PasswordField;
